import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { rem } from 'polished/lib/index';
import { RadioButton } from '../RadioButton/index';
import { __ } from '../../utilities';

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  left: 50%;
  -ms-transform: translateY(-50%);
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
  margin-top: ${rem(36)};
`;

class BusSelector extends Component {
  render() {
    const radios = [];
    for (let i = 0; i < this.props.buses.length; i++) {
      radios.push(
        <RadioButton
          key={i}
          checked={i === this.props.busDisplayed}
          onClick={() => this.props.busSelect(i)}
          name="buses"
          value={i}
          id={this.props.busId}
          label={`${__('Autobus č.')}${i + 1}`}
        />,
      );
    }
    return <Wrapper labelPosition="left">{radios}</Wrapper>;
  }
}

BusSelector.propTypes = {
  buses: PropTypes.arrayOf(PropTypes.object),
  busDisplayed: PropTypes.number,
  busId: PropTypes.number,
  busSelect: PropTypes.func,
};

BusSelector.defaultProps = {
  buses: [],
  busDisplayed: 0,
  busId: 0,
  busSelect: () => {},
};

export default BusSelector;



// WEBPACK FOOTER //
// ./src/components/BusSelector/index.js